module.exports = __webpack_public_path__ + "img/afirme.a6faabef.png";